module.exports = __webpack_public_path__ + "static/media/points.8f100fa6.svg";